module.exports = __webpack_public_path__ + "static/img/3.a117123.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/3.png
// module id = u1NG
// module chunks = 0